export default {
  title: {
    id: 'bo_sellers-opportunities-no_results_title',
    defaultMessage: 'No opportunities where found with those filters!',
  },
  description: {
    id: 'bo_sellers-opportunities-no_results_description',
    defaultMessage: 'No results!',
  },
}
